<template>
  <div class="login-page">
    <div class="login-bg" :style="{ backgroundImage: `url(${images.login_background_material})` }">
    <v-row class="pt-3 px-7" style="height:64px; align-items: center;">
      <v-row class="ma-0" style="align-items: center">
        <div class="d-inline-block">
          <v-img :src="images.KLN_logo" width=100 alt="KLNLOGO"></v-img>
        </div>
        <h2 class="ml-3 styleH2">Maintenance System</h2>
      </v-row>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="pc-only-row" style="width:130px">
            <v-row class="ma-0" v-bind="attrs" v-on="on" style="align-items: center; justify-content: center; border: 1px solid #000; border-radius:100px; width:100%">
              <v-icon class="my-1" style="color:#000">mdi-web</v-icon>
              <h4 class="ma-1">{{$t('__language')}}</h4>
            </v-row>
          </div>
          <div class="mobile-only" style="width:34px">
            <v-row class="ma-0" v-bind="attrs" v-on="on" style="align-items: center; justify-content: center; border: 1px solid #000; border-radius:100px; width:100%">
              <v-icon class="my-1" style="color:#000">mdi-web</v-icon>
            </v-row>
          </div>
        </template>
        <v-list>
          <v-list-item style="min-width: 100px;cursor: pointer" @click="language = 'tw'">
            <v-list-item-title>{{$t('__languageTw')}}</v-list-item-title>
          </v-list-item>
          <v-list-item style="min-width: 100px;cursor: pointer" @click="language = 'en'">
            <v-list-item-title>{{$t('__languageEn')}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>
    <div class="mx-n5" style="overflow-x:hidden; overflow-y:scroll" :style="viewStyle">
      <v-row class="ma-0" style="padding:4% 0px 25px 0px" justify="center">
        <v-col class="mx-5 col-10 col-md-5 col-lg-4">
          <v-card color="#FFF" style="box-shadow:none; margin-top:90px; border-radius: 26px" align="center">
            <div id="box3" class="pa-5 py-12">
              <!-- 登入表單 -->
              <div>
                <v-row style="margin-top:3%; margin-left:3%">
                  <div class="mx-5 firstBar"></div>
                  <h4 style="font-size:26px" @click="loginSimple">{{$t('__login')}}</h4>
                </v-row>
                <v-row class="mt-2" justify="center">
                  <v-col class="py-0 col-11 col-sm-10 col-md-9 col-lg-8">
                    <div class="text-left pt-6 pt14">{{$t('__account')}}</div>
                    <v-text-field class="mt-2 border pt14 login-input" dense background-color="white" outlined :placeholder="$t('__enter') + $t('__account')" v-model="account"></v-text-field>
                    <div class="text-left pt-2 pt14">{{$t('__password')}}</div>
                    <v-text-field class="text_field login-input" dense background-color="white" outlined
                      :type="showPassword ? 'text' : 'password'" autocomplete="new-password"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showPassword = !showPassword"
                      :placeholder="$t('__enter') + $t('__password')" v-model="password" @keyup.enter="login()"></v-text-field>

                    <div style="height:60px"><h4 class="pt-4 text-left" style="font-size:14px; color:#FF5A5A" v-if="isError">{{$t('__isError')}}</h4></div>
                    <v-btn class="mx-0 mb-5 colorBtn" outlined :style="{ backgroundColor: (!account || !password) ? '#C1BDBB' : '#ED6D00' }"
                      style="width:100%" @click="login" :loading="loading">
                      <span style="color:#FFFFFF; font-weight: bold; font-size: 16px">{{$t('__login')}}</span>
                    </v-btn>

                    <v-row class="ma-0 mb-4" align="center" justify="space-between">
                      <v-checkbox
                        v-model="rememberMe"
                        :label="$t('__rememberMe')"
                        hide-details
                        class="mt-0 pt-0 remember-checkbox primary-color"
                      ></v-checkbox>
                      <a href="#" class="forgot-link" @click.prevent="showForgotPassword = true">{{$t('__forgotPassword')}}</a>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col class="col-xs-0 col-md-4" align="center" style="padding:70px 0px">
          <v-img style="margin-top:50px" :src="images.KLN_login" max-width=550></v-img>
        </v-col>
      </v-row>
      <div class="pa-4 px-8" style="padding-top:60px">
        <h5 style="font-size:12px; color:#4E4E4E">© KLN Logistics Group Limited. All Rights Reserved.</h5>
        <h5 style="font-size:12px; color:#4E4E4E">Web Version: v1.0.0  | Service Version: v1.0.0</h5>
      </div>
    </div>

    <!-- 忘記密碼對話框 -->
    <v-dialog v-model="showForgotPassword" max-width="500" persistent>
      <v-card style="border-radius: 20px; padding: 40px">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="showForgotPassword = false">mdi-close</v-icon>
        </div>
        <v-card-text class="pa-0">
          <v-row justify="center" class="mt-2">
            <h2 style="font-size:28px; font-weight:bold; color:#1A1A1A">{{$t('__forgotPassword')}}</h2>
          </v-row>
          <v-row justify="center" class="ma-0 pt-3 text-center">
            <p class="mb-1" style="font-size:15px; color:#4E4E4E">{{$t('__forgotPasswordDesc')}}</p>
          </v-row>
          <div class="text-left mb-1" style="font-weight:bold; font-size:14px; color:#000">{{$t('__account')}}</div>
          <v-text-field class="forgot-input mb-4" outlined dense placeholder="example@gmail.com" v-model="forgotEmail"></v-text-field>
          <v-btn class="mb-6" block outlined
            style="height:46px; border-radius:8px; border:none"
            :style="{ backgroundColor: forgotEmail ? '#ED6D00' : '#C1BDBB' }"
            @click="handleForgotPassword" :loading="loadingReset" :disabled="!forgotEmail"
          >
            <span style="color:#FFFFFF; font-size:16px; font-weight:bold">{{$t('__sendResetLink')}}</span>
          </v-btn>
          <v-row class="ma-0" justify="center">
            <p class="ma-0" style="font-size:15px; color:#4E4E4E">
              {{$t('__goToSignIn')}}
              <a href="#" class="pl-1" @click.prevent="showForgotPassword = false" style="color:#ED6D00; text-decoration:none; font-weight:bold">{{$t('__signIn')}}</a>
            </p>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- OTP 對話框 -->
    <v-dialog v-model="showOtpInput" max-width="600" persistent>
      <v-card style="border-radius: 20px; padding: 40px">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="showOtpInput = false">mdi-close</v-icon>
        </div>
        <v-card-text>
          <v-row justify="center" class="mt-2">
            <h2 style="font-size:28px; font-weight:bold; color:#1A1A1A">Enter OTP</h2>
          </v-row>
          <v-row justify="center" class="ma-0 pt-3 text-center">
            <p class="mb-1" style="font-size:15px; color:#4E4E4E">We have sent a OTP to your email</p>
          </v-row>
          
          <!-- 6位數驗證碼輸入框 -->
          <v-row justify="center" class="mt-6 align-center">
            <div v-for="(digit, index) in otpDigits" :key="index" style="display:flex; align-items:center;">
              <v-col cols="auto" class="px-1">
                <v-text-field v-model="otpDigits[index]" :ref="'otpInput' + index"
                  outlined dense maxlength="1" type="tel" inputmode="numeric" 
                  class="otp-input" style="width:55px; text-align:center; font-size:24px"
                  @input="handleOtpInput(index)" @keydown="handleOtpKeydown($event, index)" @focus="$event.target.select()"
                ></v-text-field>
              </v-col>
              <div v-if="index !== otpDigits.length - 1" style="font-size:24px; margin:0 4px;"> - </div>
            </div>
          </v-row>
          <v-row justify="center" class="mt-3">
            <v-col cols="12">
              <v-btn class="mb-6" block outlined
                style="height:46px; border-radius:8px; border:none"
                :style="{ backgroundColor: isOtpComplete ? '#ED6D00' : '#C1BDBB' }"
                @click="verifyOtp" :loading="loading" :disabled="!isOtpComplete"
              >
                <span style="color:#FFFFFF; font-size:16px; font-weight:bold">Verify</span>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="ma-0" justify="center">
            <p class="ma-0" style="font-size:15px; color:#4E4E4E">
              Didn't receive code? 
              <a href="#" class="pl-1" @click.prevent="resendOtp" style="color:#ED6D00; text-decoration:none; font-weight:bold">Resend OTP</a>
            </p>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 重設密碼對話框 (首次登入) -->
    <v-dialog v-model="showResetPassword" max-width="550" persistent>
      <v-card style="border-radius: 20px; padding: 40px">
        <div class="close-dialog-btn mt-2" style="border-radius:14px">
          <v-icon size="28px" color="#D8DDE4" @click="showResetPassword = false">mdi-close</v-icon>
        </div>
        <v-card-text>
          <v-row justify="center" class="mt-2">
            <h2 style="font-size:28px; font-weight:bold; color:#1A1A1A">{{$t('__resetPassword')}}</h2>
          </v-row>
          <v-row justify="center" class="ma-0 pt-3 text-center">
            <p class="mb-4" style="font-size:15px; color:#4E4E4E">{{$t('__resetPasswordDesc')}}</p>
          </v-row>
          <div class="text-left mb-1" style="font-weight:bold; font-size:14px; color:#000">{{$t('__newPassword')}}</div>
          <v-text-field class="reset-input mb-2" outlined dense hide-details v-model="newPassword"
            :type="showNewPassword ? 'text' : 'password'" :placeholder="$t('__passwordHint')"
            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'" 
            @click:append="showNewPassword = !showNewPassword"
          ></v-text-field>

          <!-- 密碼強度規則清單 -->
          <div class="validation-list mb-4">
            <div class="val-item" :class="{ 'valid': passRules.hasUpper }">
              <v-icon small :color="passRules.hasUpper ? '#4CAF50' : '#9E9E9E'">{{ passRules.hasUpper ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}</v-icon>
              <span>{{$t('__passUpper')}}</span>
            </div>
            <div class="val-item" :class="{ 'valid': passRules.hasLower }">
              <v-icon small :color="passRules.hasLower ? '#4CAF50' : '#9E9E9E'">{{ passRules.hasLower ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}</v-icon>
              <span>{{$t('__passLower')}}</span>
            </div>
            <div class="val-item" :class="{ 'valid': passRules.hasNumber }">
              <v-icon small :color="passRules.hasNumber ? '#4CAF50' : '#9E9E9E'">{{ passRules.hasNumber ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}</v-icon>
              <span>{{$t('__passNumber')}}</span>
            </div>
            <div class="val-item" :class="{ 'valid': passRules.hasLength }">
              <v-icon small :color="passRules.hasLength ? '#4CAF50' : '#9E9E9E'">{{ passRules.hasLength ? 'mdi-check-circle-outline' : 'mdi-circle-outline' }}</v-icon>
              <span>{{$t('__passLength')}}</span>
            </div>
          </div>

          <div class="text-left mb-1" style="font-weight:bold; font-size:14px; color:#000">{{$t('__confirmPassword')}}</div>
          <v-text-field class="reset-input mb-1" outlined dense hide-details v-model="confirmPassword"
            :type="showConfirmPassword ? 'text' : 'password'" :placeholder="$t('__pleaseConfirmPassword')"
            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showConfirmPassword = !showConfirmPassword"
          ></v-text-field>
          <v-row class="ma-0 mb-3" style="height: 24px">
            <span v-if="confirmPassword && !passRules.isMatch" style="color: #FF5252; font-size: 14px; font-weight: bold">{{$t('__passNotMatch')}}</span>
          </v-row>
          <v-btn class="mb-3" block outlined
            style="height:46px; border-radius:8px; border:none"
            :style="{ backgroundColor: isResetFormValid ? '#ED6D00' : '#C1BDBB' }"
            @click="handleResetPassword" :loading="loadingReset" :disabled="!isResetFormValid"
          >
            <span style="color:#FFFFFF; font-size:16px; font-weight:bold">{{$t('__confirm')}}</span>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ShowMsg ref="ShowMsg" />
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js"
import ShowMsg from '@/dialogs/ShowMsg'
import i18n from '@/plugins/i18n'
import { sendVerificationCode, empLoginWithCode, empLogin, forgotPassword, resetPassword, updateLanguageSetting } from '@/api/account'
import { saveEmployeeInfo } from '@/utils/auth'

export default {
  name: 'Login',
  components: {ShowMsg},
  data:()=>({
    viewStyle:{},
    images:{
      KLN_logo: require('@/assets/image/KLN_logo.png'),
      KLN_login: require('@/assets/image/KLN_login_people.png'),
      login_background_material: require('@/assets/image/KLN_background.png'),
    },
    language:'en',
    ipData: {},
    account:'',
    password:'',
    showPassword: false,
    rememberMe:false,
    isError:false,
    // OTP 相關
    showOtpInput: false,
    otpDigits: ['', '', '', '', '', ''],
    // 忘記密碼相關
    showForgotPassword: false,
    forgotEmail: '',
    // 重設密碼相關 (首次登入)
    showResetPassword: false,
    newPassword: '',
    confirmPassword: '',
    showNewPassword: false,
    showConfirmPassword: false,
    tempUserData: null, // 暫存登入成功後的資料
    currentPassword: '', // 紀錄最後一次使用的密碼或 OTP
    loadingReset: false,
    loading: false
  }),
  computed: {
    isOtpComplete() {
      return this.otpDigits.every(digit => digit !== '')
    },
    passRules() {
      return {
        hasUpper: /[A-Z]/.test(this.newPassword),
        hasLower: /[a-z]/.test(this.newPassword),
        hasNumber: /[0-9]/.test(this.newPassword),
        hasLength: this.newPassword.length >= 12 && this.newPassword.length <= 20,
        isMatch: this.newPassword === this.confirmPassword && this.confirmPassword !== ''
      }
    },
    isResetFormValid() {
      return this.passRules.hasUpper && 
             this.passRules.hasLower && 
             this.passRules.hasNumber && 
             this.passRules.hasLength && 
             this.passRules.isMatch
    }
  },
  mounted(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
    this.language = i18n.locale
    this.getIpAddress()
    
    // 讀取記住的帳號
    const rememberedAccount = localStorage.getItem('rememberedAccount')
    if (rememberedAccount) {
      this.account = rememberedAccount
      this.rememberMe = true
    }
  },
  watch:{
    "language": {
      handler: function() {
        this.setLanguage(this.language)
        this.$root.$emit('language', this.language)
        
        const langMap = {
          'tw': 'zh-TW',
          'en': 'en-US',
          'cn': 'zh-CN'
        }
        const langSetting = langMap[this.language] || this.language
        
        // 保存到 localStorage 供 API 請求使用
        localStorage.setItem('languageSetting', langSetting)
        // 保存到 localStorage 供 i18n 插件初始化使用
        localStorage.setItem('locale', this.language)
        
        /*
        if (this.account) {
          updateLanguageSetting(this.account, langSetting).catch(err => {
            console.log('Update language setting failed:', err)
          })
        }
        */
      },
      immediate: true
    },
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    genToken(){
      let today = this.$options.filters.dateFormat(new Date(),'YYYYMMDD')

      let result = CryptoJS.MD5(this.account).toString() + CryptoJS.MD5(today).toString()

      sessionStorage.setItem('manageMemberToken', result.toUpperCase())
    },
    getIpAddress() {
      var self = this;
      var API_URL = 'https://ipinfo.io/json';  // 使用 ipinfo.io
      fetch(API_URL)
        .then(response => response.json())
        .then(result => {
          self.ipData = result
          // console.log(self.ipData.ip);  // 打印 IP 地址
        })
        .catch(err => {
          console.log(err);
          self.$refs.ShowMsg.open(0, this.$t('__error'), this.$t('__systemError', { code: 'lgn-7979' }));
        });
    },
    setLanguage(language){
      switch(language){
        case 'tw':
        case 'cn':
        case 'en':
          i18n.locale = language
          // sessionStorage.setItem('locale', language)
          // this.$cookie.set('language', language, 30)
          break
        default:
          break
      }
    },
    // 步驟 1: 發送驗證碼
    async login(){
      this.isError = false
      this.loading = true
      
      // 表單驗證
      if(!this.account || !this.password){
        this.isError = true
        this.loading = false
        return
      }

      // 記住我邏輯
      if (this.rememberMe) {
        localStorage.setItem('rememberedAccount', this.account)
      } else {
        localStorage.removeItem('rememberedAccount')
      }

      try {
        console.log('🔐 步驟1: 發送驗證碼...', {
          account: this.account,
          password: '***'
        })

        // 調用 SendVerificationCode API
        const response = await sendVerificationCode(this.account, this.password)
        
        console.log('📡 響應:', response)

        // 檢查是否成功發送驗證碼
        if (response.State === '101') {
          console.log('✅ 驗證碼已發送')
          
          // 直接切換到 OTP 輸入介面（不顯示成功訊息）
          this.showOtpInput = true
          this.isError = false
          
          // 聚焦第一個 OTP 輸入框
          this.$nextTick(() => {
            if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
              this.$refs.otpInput0[0].focus()
            }
          })
        } else if (response.State === '108') {
          
          console.log('✅ 登入成功！')
          // 保存員工資訊
          if (response.Data && response.Data.Token) {
            this.handleLoginLanguage(response.Data)
            saveEmployeeInfo(response.Data)
            this.currentPassword = this.password
            
            // 保存登入帳號供後端更新語言設定使用
            sessionStorage.setItem('loginAccount', this.account)
            
            // 兼容舊代碼，同時保存到 sessionStorage
            const today = this.$options.filters.dateFormat(new Date(), 'YYYYMMDD')
            const dateMd5 = CryptoJS.MD5(today).toString().toUpperCase()
            sessionStorage.setItem('manageMemberToken', response.Data.Token + dateMd5)
            sessionStorage.setItem('manageMemberName', response.Data.name || '')
            sessionStorage.setItem('manageMemberSysId', response.Data.employeeId || '')
            
            this.$root.LOGININFO = {
              name: response.Data.name
            }
            
            // 檢查是否為首次登入 (或臨時密碼) - 根據後端回傳欄位 requirePasswordReset
            if (response.Data.requirePasswordReset || response.Data.IsTempPasswordLogin || 
                response.Data.IsFirstLogin || response.Data.IsTempPassword) {
              console.log('🔄 偵測到需要重設密碼 (requirePasswordReset)')
              this.tempUserData = response.Data
              this.showOtpInput = false
              this.showResetPassword = true
              return
            }

            // 顯示成功訊息
            this.$refs.ShowMsg.open(0, this.$t('__success'), response.Message || this.$t('__loginSuccess'))
            
            // 延遲跳轉
            setTimeout(() => {
              this.redirectPath('/home')
            }, 500)
          } else {
            this.$refs.ShowMsg.open(0, '錯誤', '返回資料格式錯誤')
          }
        } else {
          // 發送失敗 - 優先顯示 ErrorMessage
          const errorMsg = this.language === 'en' 
            ? (response.Message || response.ErrorMessage || 'Send verification code failed') 
            : (response.ErrorMessage || response.Message || '發送驗證碼失敗')
          console.error('❌ 發送失敗:', errorMsg)
          this.isError = true
          this.$refs.ShowMsg.open(0, '失敗', errorMsg)
        }
      } catch (error) {
        console.error('❌ 錯誤:', error)
        this.isError = true
        let errorMsg = this.$t('__networkError')
        if (error.response && error.response.data) {
          const res = error.response.data
          errorMsg = this.language === 'en' 
            ? (res.Message || res.ErrorMessage || errorMsg) 
            : (res.ErrorMessage || res.Message || errorMsg)
        }
        this.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      } finally {
        this.loading = false
      }
    },

    // 步驟 2: 驗證 OTP 並完成登入
    async verifyOtp() {
      if (!this.isOtpComplete) {
        return
      }

      this.loading = true
      const verificationCode = this.otpDigits.join('')

      try {
        console.log('🔐 步驟2: 驗證 OTP...', {
          account: this.account,
          code: verificationCode
        })

        // 調用 EmpLoginWithCode API
        const response = await empLoginWithCode(this.account, verificationCode)
        
        console.log('📡 登入響應:', response)

        // 檢查登入是否成功 (State = '108')
        if (response.State === '108' || response.State === '101') {
          console.log('✅ 登入成功！')
          
          // 保存員工信息
          if (response.Data && response.Data.Token) {
            this.handleLoginLanguage(response.Data)
            saveEmployeeInfo(response.Data)
            
            // 兼容舊代碼，同時保存到 sessionStorage
            const today = this.$options.filters.dateFormat(new Date(), 'YYYYMMDD')
            const dateMd5 = CryptoJS.MD5(today).toString().toUpperCase()
            sessionStorage.setItem('manageMemberToken', response.Data.Token + dateMd5)
            sessionStorage.setItem('manageMemberName', response.Data.name || '')
            sessionStorage.setItem('manageMemberSysId', response.Data.employeeId || '')
            sessionStorage.setItem('loginAccount', this.account)
            
            this.$root.LOGININFO = {
              name: response.Data.name
            }
            
            // 檢查是否為首次登入 (或臨時密碼) - 根據後端回傳欄位 requirePasswordReset
            if (response.Data.requirePasswordReset || response.Data.IsTempPasswordLogin ||
                response.Data.IsFirstLogin || response.Data.IsTempPassword) {
              console.log('🔄 偵測到需要重設密碼 (requirePasswordReset)')
              this.tempUserData = response.Data
              this.currentPassword = verificationCode
              this.showOtpInput = false
              this.showResetPassword = true
              return
            }

            // 顯示成功訊息
            this.$refs.ShowMsg.open(0, this.$t('__success'), response.Message || this.$t('__loginSuccess'))
            
            // 延遲跳轉
            setTimeout(() => {
              this.redirectPath('/home')
            }, 500)
          } else {
            this.$refs.ShowMsg.open(0, '錯誤', '返回數據格式錯誤')
          }
        } else {
          // 驗證失敗
          const errorMsg = this.language === 'en' 
            ? (response.Message || response.ErrorMessage || 'Verification code error') 
            : (response.ErrorMessage || response.Message || '驗證碼錯誤')
          console.error('❌ 驗證失敗:', errorMsg)
          this.$refs.ShowMsg.open(0, '驗證失敗', errorMsg)
          
          // 清空 OTP 輸入
          this.otpDigits = ['', '', '', '', '', '']
          this.$nextTick(() => {
            if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
              this.$refs.otpInput0[0].focus()
            }
          })
        }
      } catch (error) {
        console.error('❌ 驗證錯誤:', error)
        let errorMsg = this.$t('__networkError')
        if (error.response && error.response.data) {
          const res = error.response.data
          errorMsg = this.language === 'en' 
            ? (res.Message || res.ErrorMessage || errorMsg) 
            : (res.ErrorMessage || res.Message || errorMsg)
        }
        this.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      } finally {
        this.loading = false
      }
    },

    // OTP 輸入處理
    handleOtpInput(index) {
      if (!this.otpDigits[index]) return;
      // 覆寫成最後一個輸入的字符
      if (this.otpDigits[index].length > 1) {
        this.otpDigits[index] = this.otpDigits[index].slice(-1)
      }
      this.otpDigits[index] = this.otpDigits[index].replace(/[^0-9]/g, '')
      
      // 自動跳到下一個輸入框
      if (this.otpDigits[index] && index < 5) {
        const nextInput = this.$refs['otpInput' + (index + 1)]
        if (nextInput && nextInput[0]) {
          nextInput[0].focus()
        }
      }
    },

    // OTP 鍵盤處理
    handleOtpKeydown(event, index) {
      // 僅允許數字 (0-9)、BackSpace, Delete, 方向鍵, Tab 等控制鍵
      const isNumber = /[0-9]/.test(event.key)
      const isControl = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)
      const isCombination = event.ctrlKey || event.metaKey // Ctrl+C, Ctrl+V
      
      if (!isNumber && !isControl && !isCombination) {
        event.preventDefault()
        return // 阻斷往下運作
      }

      // 處理退格鍵
      if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
        const prevInput = this.$refs['otpInput' + (index - 1)]
        if (prevInput && prevInput[0]) {
          prevInput[0].focus()
        }
      }
    },

    // 重新發送驗證碼
    async resendOtp() {
      this.loading = true
      try {
        const response = await sendVerificationCode(this.account, this.password)
        if (response.State === '101') {
          this.$refs.ShowMsg.open(0, this.$t('__success'), this.$t('__otpResentSuccess'))
          this.otpDigits = ['', '', '', '', '', '']
          this.$nextTick(() => {
            if (this.$refs.otpInput0 && this.$refs.otpInput0[0]) {
              this.$refs.otpInput0[0].focus()
            }
          })
        }
      } catch (error) {
        this.$refs.ShowMsg.open(0, this.$t('__error'), this.$t('__otpResentFail'))
      } finally {
        this.loading = false
      }
    },
    async loginSimple(){
      this.loading = true
      
      // 記住我邏輯 (Android 集成)
      if (this.rememberMe) {
        localStorage.setItem('rememberedAccount', this.account)
        console.log('autoLogin=true')
        console.log('loginAccount=' + this.account)
        console.log('loginPassword=' + this.password)
      } else {
        localStorage.removeItem('rememberedAccount')
        console.log('autoLogin=false')
        console.log('loginAccount=')
        console.log('loginPassword=')
      }

      try {
        console.log('🔐 簡易登入...', {
          account: this.account,
          password: this.password
        })

        // 調用 EmpLoginWithCode API
        const response = await empLogin(this.account, this.password)
        
        console.log('📡 登入響應:', response)

        // 檢查登入是否成功 (State = '108')
        if (response.State === '108' || response.State === '101') {
          console.log('✅ 登入成功！')
          
          // 保存員工信息
          if (response.Data && response.Data.Token) {
            this.handleLoginLanguage(response.Data)
            saveEmployeeInfo(response.Data)
            
            // 兼容舊代碼，同時保存到 sessionStorage
            const today2 = this.$options.filters.dateFormat(new Date(), 'YYYYMMDD')
            const dateMd52 = CryptoJS.MD5(today2).toString().toUpperCase()
            sessionStorage.setItem('manageMemberToken', response.Data.Token + dateMd52)
            sessionStorage.setItem('manageMemberName', response.Data.name || '')
            sessionStorage.setItem('manageMemberSysId', response.Data.employeeId || '')
            sessionStorage.setItem('loginAccount', this.account)
            
            this.$root.LOGININFO = {
              name: response.Data.name
            }
            
            // 顯示成功訊息
            this.$refs.ShowMsg.open(0, this.$t('__success'), response.Message || this.$t('__loginSuccess'))
            
            // 延遲跳轉
            setTimeout(() => {
              this.redirectPath('/home')
            }, 500)
          } else {
            this.$refs.ShowMsg.open(0, '錯誤', '返回數據格式錯誤')
          }
        } else {
          // 驗證失敗
          const errorMsg = this.language === 'en' 
            ? (response.Message || response.ErrorMessage || 'Verification code error') 
            : (response.ErrorMessage || response.Message || '驗證碼錯誤')
          console.error('❌ 驗證失敗:', errorMsg)
          this.$refs.ShowMsg.open(0, '驗證失敗', errorMsg)
        }
      } catch (error) {
        console.error('❌ 驗證錯誤:', error)
        let errorMsg = this.$t('__networkError')
        if (error.response && error.response.data) {
          const res = error.response.data
          errorMsg = this.language === 'en' 
            ? (res.Message || res.ErrorMessage || errorMsg) 
            : (res.ErrorMessage || res.Message || errorMsg)
        }
        this.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      } finally {
        this.loading = false
      }
    },
    updateSystemPermission(content){
      content = JSON.parse(content.replace(/(['\"])?([a-zA-Z0-9_]+)(['\"])?:([^\/])/g, '"$2":$4'))
      sessionStorage.setItem('SYS-PERMISSION',JSON.stringify(content))
      this.$system.system = content.system
      this.$system.operation = content.operation

      this.$system.dean = content.dean

      this.$system.employeelist = content.employeelist
      this.$system.authlist = content.authlist
      this.$system.orderlist = content.orderlist
      this.$system.healthydoclist = content.healthydoclist
      this.$system.neolist = content.neolist

      this.$system.clinicroom = content.clinicroom
      this.$system.devicetransfer = content.devicetransfer

      this.$system.couponlist = content.couponlist
      this.$system.coupondelivery = content.coupondelivery
      this.$system.faqlist = content.faqlist

      this.$system.mailbox = content.mailbox
    },
    async handleForgotPassword() {
      if (!this.forgotEmail) return
      this.loadingReset = true
      try {
        const response = await forgotPassword(this.forgotEmail)
        if (response.State === '101') {
          this.$refs.ShowMsg.open(0, this.$t('__success'), response.Message || '密碼重置連結已發送到您的電子信箱')
          this.showForgotPassword = false
          this.forgotEmail = ''
        } else {
          const errorMsg = this.language === 'en' 
            ? (response.Message || response.ErrorMessage || 'Failed to send, please confirm if mailbox is correct') 
            : (response.ErrorMessage || response.Message || '發送失敗，請確認信箱是否正確')
          this.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
        }
      } catch (error) {
        this.$refs.ShowMsg.open(0, this.$t('__error'), this.$t('__networkError'))
      } finally {
        this.loadingReset = false
      }
    },
    async handleResetPassword() {
      if (!this.isResetFormValid) return
      this.loadingReset = true
      try {
        // 使用 resetPassword API
        // 注意：這裡假設帳號是 this.account，code 是剛才的 OTP (如果是 OTP 登入) 
        // 或是從 tempUserData 中取得必要的識別
        const response = await resetPassword(this.account, this.currentPassword, this.newPassword)
        
        if (response.State === '103') {
          this.$refs.ShowMsg.open(0, this.$t('__success'), response.Message || '密碼重設成功，請使用新密碼重新登入')
          this.showResetPassword = false
          // 重設完成後通常需要重新登入
          setTimeout(() => {
            location.reload()
          }, 1500)
        } else {
          const errorMsg = this.language === 'en' 
            ? (response.Message || response.ErrorMessage || 'Password reset failed') 
            : (response.ErrorMessage || response.Message || '重設失敗')
          this.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
        }
      } catch (error) {
        console.error('❌ 錯誤:', error)
        let errorMsg = this.$t('__networkError')
        if (error.response && error.response.data) {
          const res = error.response.data
          errorMsg = this.language === 'en' 
            ? (res.Message || res.ErrorMessage || errorMsg) 
            : (res.ErrorMessage || res.Message || errorMsg)
        }
        this.$refs.ShowMsg.open(0, this.$t('__error'), errorMsg)
      } finally {
        this.loadingReset = false
      }
    },
    handleLoginLanguage(data) {
      if (data && data.languageSetting) {
        const reverseLangMap = {
          'zh-TW': 'tw',
          'en-US': 'en',
          'zh-CN': 'cn'
        }
        const localLang = reverseLangMap[data.languageSetting]
        if (localLang && localLang !== this.language) {
          console.log('🌐 Auto-switching language to:', localLang)
          this.language = localLang
        }
      }
    }
  }
}
</script>


<style scoped>
  .login-page {
    overflow: hidden;
    background-color: #FFFCF9;
  }

  /* 背景主容器 */
  .login-bg {
    min-height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center bottom;
  }

  /* header */
  .header-row {
    height: 64px;
    align-items: center;
  }

  /* 平板 */
  @media (max-width: 1263px) {
    .login-bg {
      background-position: center center;
    }
  }

  /* 手機 */
  @media (max-width: 959px) {

    .login-bg {
      background-size: 100%;  /* 👈 比 contain 再大一點 */
      background-position: center bottom;
      background-color: #FFFCF9;    /* 避免白邊 */
    }
  }

  @media (max-width: 959px) {
    .col-xs-0 {
      display: none;
    }
    .hamburger {
      display: unset !important;
      width: 50px !important;
    }
    .breadcrumb, .headerName, .app-content-left {
      display: none !important;
    }
  }
  
  /* OTP 輸入框樣式 */
  .otp-input >>> input {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #667085;
  }
  
  .otp-input >>> fieldset {
    border: 2px solid #ED6D00 !important;
  }
  
  .otp-input >>> .v-text-field__slot input {
    text-align: center;
  }


  .forgot-link {
    color: #ED6D00;
    text-decoration: none;
    font-size: 14px;
    font-weight: 700;
    font-family: inherit;
  }

  .forgot-link:hover {
    text-decoration: underline;
  }

  .remember-checkbox >>> .v-icon {
    font-size: 20px !important;
  }

  .remember-checkbox >>> .v-label {
    font-size: 14px;
    color: #4E4E4E !important;
    font-weight: 700;
    font-family: inherit;
    letter-spacing: normal;
  }

  /* 兼容一些舊瀏覽器或特定組件結構 */
  .remember-checkbox >>> label {
    font-size: 14px;
    color: #4E4E4E !important;
    font-weight: 700;
    font-family: inherit;
    letter-spacing: normal;
  }

  .forgot-input >>> .v-input__slot {
    border-radius: 8px !important;
  }

  .validation-list {
    display: flex;
    flex-direction: column;
    /* gap: 8px; */
  }

  .val-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #9E9E9E;
    transition: color 0.3s;
  }

  .val-item.valid {
    color: #4CAF50;
  }

  .reset-input >>> .v-input__slot {
    border-radius: 8px !important;
  }

  /* Login Input Styles Override */
  .login-input.v-text-field--outlined fieldset {
    border-color: #4E4E4E !important;
  }
  
  .login-input .v-input__icon .v-icon {
    color: #4E4E4E !important;
  }

  /* Ensure the label/placeholder or other elements that might pick up the primary color also respect the wish if needed, 
     but for now specifically targeting border and icon as requested. */
</style>

